import React, { useRef } from "react";
import { useImpressionObserver } from "../../../hooks/useAnalyticsTracker";

export const TrackImpression = ({ propertyId, children }) => {
  const ref = useRef(null);
  useImpressionObserver(ref, propertyId);

  return <div ref={ref}>{children}</div>;
};
